import PropTypes from 'prop-types'

import CheckBox from 'components/common/CheckBox'
import theme from 'theme'
import SignedOutForm, {
  SignedOutFormContainer,
  UpperBackText
} from 'components/authentication/SignedOutForm'
import Flex from 'components/common/Flex'
import InputTextField from 'components/common/InputTextField'
import Button from 'components/common/Button'
import Hr from 'components/common/Hr'
import Password from 'components/authentication/form-fields/Password'
import DividerWithText from 'components/common/DividerWithText'

export default function SignUpForm(props) {
  const {
    email,
    firstName,
    lastName,
    requestedDemo,
    disabled,
    handleEmailChange,
    handleFirstNameChange,
    handleLastNameChange,
    handlerequestedDemoChange,
    handleSignUp,
    handleGoogle
  } = props

  return (
    <SignedOutFormContainer>
      <UpperBackText to="/login">Log in</UpperBackText>
      <SignedOutForm
        title="Sign up for Gremlin Free"
        onSubmit={event => {
          event.preventDefault()
          handleSignUp && handleSignUp()
        }}
      >
        <Flex column data-test-signup-form>
          <InputTextField
            data-test-signup-email
            autoComplete="email"
            disabled={disabled}
            innerRef={ref => ref && ref.focus()}
            label="Email address"
            name="email"
            readOnly={!handleEmailChange}
            value={email}
            onChange={event =>
              handleEmailChange && handleEmailChange(event.target.value)
            }
          />
          <Flex>
            <InputTextField
              data-test-signup-first-name
              disabled={disabled}
              label="First name"
              maxLength={50}
              name="first-name"
              noRightRadius={true}
              readOnly={!handleFirstNameChange}
              value={firstName}
              onChange={event =>
                handleFirstNameChange &&
                handleFirstNameChange(event.target.value)
              }
            />
            <InputTextField
              data-test-signup-last-name
              disabled={disabled}
              label="Last name"
              maxLength={50}
              name="last-name"
              noLeftRadius={true}
              readOnly={!handleLastNameChange}
              value={lastName}
              onChange={event =>
                handleLastNameChange && handleLastNameChange(event.target.value)
              }
            />
          </Flex>
          <Button
            data-test-signup-continue
            stretch
            disabled={isFormInvalid(props) || disabled}
            label="Continue with email"
            type="submit"
          />
          <DividerWithText />
          <Password
            googleText="Sign up with Google"
            handleGoogle={handleGoogle}
            signInMethods={['google']}
          />
        </Flex>
        <Hr css={{ marginTop: theme.space[3], marginBottom: theme.space[5] }} />
        <div css={{ textAlign: 'left' }}>
          <CheckBox
            checked={requestedDemo}
            id="requestedDemo"
            label="I'd also like someone to contact me to schedule a demo of Gremlin."
            name="requestedDemo"
            onChange={event => handlerequestedDemoChange(event.target.checked)}
          />
        </div>
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}

function isFormInvalid({ email, firstName, lastName }) {
  return !email.length || !firstName.length || !lastName.length
}

SignUpForm.propTypes = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  requestedDemo: PropTypes.bool.isRequired,
  handleEmailChange: PropTypes.func,
  handleLastNameChange: PropTypes.func,
  handleFirstNameChange: PropTypes.func,
  handlerequestedDemoChange: PropTypes.func,
  handleBack: PropTypes.func,
  handleSignUp: PropTypes.func,
  handleGoogle: PropTypes.func
}

SignUpForm.defaultProps = {
  email: '',
  firstName: '',
  lastName: '',
  role: '',
  requestedDemo: false,
  disabled: false
}
